import { Row } from 'antd';
import { Store } from 'antd/lib/form/interface';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import FormWrapper from 'components/molecules/FormWrapper';
import emailCheckValidation from 'enums/validations/emailCheckValidation';
import emailValidation from 'enums/validations/emailValidation';
import notRequired from 'enums/validations/notRequired';
import phoneValidation from 'enums/validations/phoneValidation';
import React, { useState } from 'react';
import { IZadostData } from 'services/bankid/zadost';
import IDEN from './stavPages/IDEN';

interface IVypisKontaktniUdaje {
    zadostData?: IZadostData;
}

const VypisKontaktniUdaje: React.FC<IVypisKontaktniUdaje> = props => {
    const { zadostData } = props;
    const [showObjednavka, setShowObjednavka] = useState<boolean>(false);
    const [contactInfoEmail, setContactInfoEmail] = useState<string>();
    const [contactInfoPhone, setContactInfoPhone] = useState<string>();

    const onFinish = (value: Store) => {
        setContactInfoEmail(value.email ? value.email.toString() : zadostData?.email);
        value.phone && setContactInfoPhone(value.phone.toString());
        (contactInfoEmail && contactInfoPhone) ?? setShowObjednavka(true);
    };

    return (
        <>
            {showObjednavka ? (
                <IDEN
                    zadostData={zadostData}
                    contactInfoEmail={contactInfoEmail}
                    contactInfoPhone={contactInfoPhone}
                    setContactInfoEmail={setContactInfoEmail}
                />
            ) : (
                <div className="section-kontaktni-udaje">
                    <Paragraph text="VYPLNTE_CHYBEJICI_UDAJE" strong={true} />

                    <FormWrapper onFinish={onFinish}>
                        {zadostData?.email ? (
                            <></>
                        ) : (
                            <>
                                <InputComponent
                                    name="email"
                                    label="EMAIL"
                                    type="email"
                                    rules={
                                        zadostData?.email ? notRequired() : emailValidation('NEVALIDNI_POVINNA_POLOZKA')
                                    }
                                />
                                <InputComponent
                                    name="emailCheck"
                                    label="EMAIL_CHECK"
                                    type="email"
                                    dependencies={['email']}
                                    rules={
                                        zadostData?.email
                                            ? notRequired()
                                            : emailCheckValidation('NEVALIDNI_POVINNA_POLOZKA', 'email')
                                    }
                                />
                            </>
                        )}

                        {zadostData?.telefon ? (
                            <></>
                        ) : (
                            <>
                                <InputComponent
                                    name="phone"
                                    label="PHONE_NUMBER"
                                    type="tel"
                                    rules={
                                        zadostData?.telefon
                                            ? notRequired()
                                            : phoneValidation('NEVALIDNI_POVINNA_POLOZKA')
                                    }
                                    autoComplete="tel"
                                />
                            </>
                        )}

                        <Row className="statement-buttons-row">
                            <ButtonComponent buttontext="POKRACOVAT" htmlType="submit" />
                        </Row>
                    </FormWrapper>
                </div>
            )}
        </>
    );
};

export default VypisKontaktniUdaje;
